import { useMutation } from "@tanstack/react-query";
import { UpdateVenueParams, updateVenue } from "supabase/venues";
import { queryClient } from "utils";

export const useUpdateVenue = (onSuccess: () => any) => {
  const mutation = useMutation({
    mutationFn: (venue: UpdateVenueParams) => {
      return updateVenue(venue);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["venues"],
      });
      queryClient.invalidateQueries({
        queryKey: ["venue", variables.uid],
      });

      onSuccess();
    },
  });

  return mutation;
};
